class TabbedCollection extends HTMLElement {

  constructor() {
    super();

    this.selectors = {
      swiper: "swiper-container",
      scroll: ".swiper-scrollbar",
      prevEl: ".custom-prev-button",
      nextEl: ".custom-next-button"
    }

    this.slider = this.querySelector(this.selectors.swiper);
    this.scrollbar = this.querySelector(this.selectors.scroll);
    this.buttonPrev = this.querySelector(this.selectors.prevEl);
    this.buttonNext = this.querySelector(this.selectors.nextEl);
    this.initSlider();
  }

  initSlider() {
    const swiperParams = {
      slidesPerView: 2.2115,
      spaceBetween: 12,
      slidesOffsetBefore: 15,
      slidesOffsetAfter: 15,
      breakpoints: {
        640: {
          slidesPerView: "auto",
          spaceBetween: 12,
          slidesOffsetBefore: 15,
          slidesOffsetAfter: 15,
        },
        750: {
          slidesPerView: "auto",
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 15,
        }
      },
      navigation: {
        nextEl: this.buttonNext,
        prevEl: this.buttonPrev
      },
      scrollbar: {
        el: this.scrollbar,
        draggable: true,
      },
      on: {
        init() {
        }
      },
    };

    Object.assign(this.slider, swiperParams);

    this.slider.initialize();

  }
}

customElements.define('component-tabbed-collection', TabbedCollection);